import { useIntl } from "react-intl";

import { Icon, JumpTo, Msg } from "@shared/components";

export const HelpLink = () => {
  const intl = useIntl();

  const helpLink = intl.formatMessage({
    id: "editor-exam-detail.modals.help-link",
  });

  return (
    <JumpTo to={helpLink} className="code-editor-exam-detail__helplink">
      <Msg id="editor-exam-detail.modals.fourthModal.issue-text"></Msg>
      <Icon type="external-link" />
    </JumpTo>
  );
};
